export default class FireSidebarTools {
  public static isActive(itemId: string, comparableId: string): string {
    if (!itemId) return '';

    return comparableId === itemId ? 'is-active' : '';
  }
}
